/* 渲染作者信息 */
import React, { useState, useEffect, useContext } from 'react'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
import Link from 'next/link'
import classNames from 'classnames'
import get from 'lodash/get'

import { sendTeaCommEvent } from 'lib/tea-analyze'
import { focus } from 'lib/ugc-interact'
import applyHttpsImage from 'lib/apply-https-img'
import { getLoginHref } from 'lib/get-login-href'
import { GlobalStoreContext } from 'Components/store'
import { LoginStoreContext } from 'New/login/login-store'

export interface IAuthor {
  fans_count: number
  following_num: number
  subscribed: number
  description: string
  avatar_url: string
  name: string
  media_id: number
  user_id: number
  motor_auth_show_info: {
    auth_v_desc: string
    auth_v_type: number
  }
}

interface IProps {
  author: IAuthor
  gid: string
}

export default function renderAuthor({ author, gid }: IProps) {
  const {
    media_id,
    user_id,
    name,
    subscribed,
    avatar_url,
    fans_count,
    following_num,
    motor_auth_show_info,
    description,
  } = author
  const auth_description =
    motor_auth_show_info && motor_auth_show_info.auth_v_desc
  const { state: globalState } = useContext(GlobalStoreContext)
  const { openLogin } = useContext(LoginStoreContext)
  const [isSubscribing, setIsSubscribing] = useState(subscribed)
  const [fansCount, setFansCount] = useState(fans_count)
  const handleFocusClick = () => {
    if (isSubscribing) return
    const my_user_id = get(globalState, 'userData.user_id')
    if (!my_user_id) {
      openLogin({
        enter_method: 'follow',
      })
      return
    }
    // 先假设关注成功
    setIsSubscribing(1)
    setFansCount(fansCount + 1)
    focus({
      user_id,
      to_user_id: media_id || user_id,
    }).catch(() => {
      // 如果失败了，重置关注状态
      setIsSubscribing(0)
      setFansCount(fansCount)
    })
  }
  useEffect(() => {
    setIsSubscribing(subscribed)
  }, [subscribed])
  useEffect(() => {
    setFansCount(fans_count)
  }, [fans_count])
  return (
    <div className="author">
      <h2>作者</h2>
      <Link
        href={`/profile?mediaId=${media_id}&theUserId=${user_id}&gid=${gid}`}
        as={`/user/${media_id ? 'profile' : 'ugc_profile'}/${
          media_id || user_id
        }?gid=${gid}`}
      >
        <a target={'_blank'}>
          <header className="clearfix">
            <i
              className="portrait fl"
              onClick={() => {
                sendTeaCommEvent('click_author_portrait', {
                  group_id: gid,
                  media_id,
                })
              }}
            />
            <div className="fl">
              <p
                onClick={() => {
                  sendTeaCommEvent('click_author_name', {
                    group_id: gid,
                    media_id,
                  })
                }}
                className="name line-1"
              >
                {name}
              </p>
              <p className="series line-1">
                {following_num > 0 && (
                  <span>
                    <span className="number">{following_num}</span>
                    关注
                  </span>
                )}
                <span>
                  <span className="number">{formatNumber(fansCount)}</span>
                  粉丝
                </span>
              </p>
            </div>
          </header>
        </a>
      </Link>
      <div
        className={classNames('focus-button', {
          subscribed: isSubscribing,
        })}
        onClick={handleFocusClick}
      >
        {isSubscribing ? '已关注' : '关注'}
      </div>
      {auth_description || description ? (
        <div className="bottom-info">
          {auth_description ? (
            <p className="info line-1">
              <span className="icon-icon-credentials info-icon" />
              <span className="bold">认证信息：</span>
              {motor_auth_show_info.auth_v_desc}
            </p>
          ) : null}
          {description ? (
            <p className="describe line-2">
              <span className="icon-icon-description info-icon" />
              <span className="bold">个人描述：</span>
              {description}
            </p>
          ) : null}
        </div>
      ) : null}
      <style jsx>
        {`
          .author {
            width: 390px;
            margin-bottom: 10px;
            border: solid 1px #e6e6e6;
          }
          h2 {
            position: relative;
            width: 390px;
            line-height: 60px;
            padding-left: 26px;
            font-size: 18px;
            font-weight: 500;
            border-bottom: solid 1px #e6e6e6;
          }
          h2::before {
            content: '';
            position: absolute;
            top: 21px;
            left: 16px;
            width: 6px;
            height: 18px;
            background: #ffe100;
          }
          header {
            padding: 24px 24px 20px;
          }
          .portrait {
            width: 56px;
            height: 56px;
            margin-right: 14px;
            border-radius: 50%;
            border: solid 1px #e6e6e6;
            background: url('${applyHttpsImage(avatar_url || '')}') no-repeat
              center / 60px 60px;
          }
          .name {
            line-height: 26px;
            margin: 4px 0;
            font-size: 20px;
            font-weight: 500;
          }
          .series {
            color: #999999;
          }
          .series span {
            margin-right: 12px;
          }
          .series .number {
            margin-right: 2px;
            color: #1a1a1a;
            font-weight: bold;
          }
          .focus-button {
            height: 36px;
            margin: 0 24px 25px;
            font-size: 16px;
            line-height: 36px;
            color: #1a1a1a;
            text-align: center;
            border-radius: 4px;
            background-color: #ffe100;
            font-weight: bold;
            cursor: pointer;
          }
          .focus-button.subscribed {
            background-color: rgba(0, 0, 0, 0.06);
            color: rgba(0, 0, 0, 0.32);
            cursor: auto;
          }
          .bottom-info {
            padding: 24px;
            background-color: #f8f8f8;
          }
          .bottom-info p {
            font-size: 14px;
            line-height: 20px;
            color: #666666;
          }
          .bottom-info p:nth-child(2) {
            margin-top: 8px;
          }
          .bottom-info p .bold {
            color: #1a1a1a;
            font-weight: bold;
          }
          .info-icon {
            display: inline-block;
            font-size: 16px;
            vertical-align: middle;
            margin-top: -3px;
            margin-right: 4px;
            font-weight: bold;
          }
          .description {
            width: 24xpx;
            display: inline-block;
          }
        `}
      </style>
    </div>
  )
}
